module.exports = __webpack_public_path__ + "static/media/gt-america-standard-regular.682fe21e.woff";